import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import BackorderService from '../services/BackorderService';

const initialState = {
    backorders: [],
    loading: false,
    error: null,
};

export const fetchBackorders = createAsyncThunk(
    'backorder/fetchBackorders',
    async (params, { rejectWithValue }) => {
        try {
            const resp = await BackorderService.List(params);
            return resp;
        } catch (e) {
            return rejectWithValue(e.response);
        }
    },
);

const backorderSlice = createSlice({
    name: 'backorder',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBackorders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBackorders.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload?.status === 200) {
                    state.backorders = action.payload?.data?.data || [];
                } else {
                    state.error = action.payload?.data?.message;
                    toast.error(state.error);
                }
            })
            .addCase(fetchBackorders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });
    },
});

export default backorderSlice.reducer;
